import { useTranslation } from 'react-i18next';

/** Footer chip of the current Excel selection (design 1b). Off when the pane opens or a conversation starts, on as
 *  soon as the user selects something (product owner, 2026-09-10 — `useSelectionOptIn`): a muted "+ Sheet!A1" chip
 *  adds it by hand to the next messages as the pointer for "this cell / here" (PLAN #11); added, the chip turns
 *  accent with a × that removes it again until the next selection gesture. */
export function SelectionChip({ selection, included, onToggle }: { selection: { sheet: string; address: string } | null; included: boolean; onToggle: (included: boolean) => void }) {
  const { t } = useTranslation();
  if (!selection) return null;
  const ref = `${selection.sheet}!${selection.address}`;
  return (
    <div className="flex flex-wrap gap-1.5">
      {included ? (
        <div className="flex items-center gap-1.5 rounded-sm bg-accent-bg py-[3px] pl-2 pr-1 font-mono text-[11px] text-accent-dark" title={t('context.selectionHint')} data-testid="selection-chip" data-included="true">
          {ref}
          <button type="button" onClick={() => onToggle(false)} aria-label={t('context.removeSelection')} title={t('context.removeSelection')} className="grid h-4 w-4 place-items-center rounded-sm text-[12px] leading-none opacity-70 hover:bg-white/60 hover:opacity-100">
            ×
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => onToggle(true)} aria-label={t('context.addSelection')} title={t('context.addSelection')} data-testid="selection-chip" data-included="false" className="flex items-center gap-1 rounded-sm border border-dashed border-line px-2 py-[3px] font-mono text-[11px] text-faint transition-colors hover:border-accent hover:text-accent-dark">
          <span className="text-[12px] leading-none">+</span>
          {ref}
        </button>
      )}
    </div>
  );
}
